import { Fragment } from 'react';
import './CustomItemCardWidget.scss';

export default function CustomItemCardWidget({ title, info, icon = null }) {
    return (
        <div className='custom_item_card'>
            {icon ? icon : <Fragment></Fragment>}
            <div className='item_card_details'>
                <p className='card_title'>{title}</p>
                <p className='note'>{info}</p>
            </div>
        </div>
    )
}